import React, { Fragment, useEffect, useState } from 'react'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import { Modal } from 'antd'
import { FullPageSpinner, PageAlert } from 'components'
import ScanFilterBar from 'views/ScanSettings/components/ScanFilterBar'
import ScanViewWidgets from 'views/ScanSettings/components/ScanView/ScanViewWidgets'
import ScanViewData from 'views/ScanSettings/components/ScanView/ScanViewData'

const ScanView = props => {
  const {
    scanViewData,
    customColumns,
    scanStatus,
    fetchData,
    fetchDetails,
    loadingData,
    fetchError,
    withPolling,
    widgets,
    widgetsGrid,
    isDetailsView,
    setDetailsView,
    isScanCompare,
    compareData,
    details,
    scanSettingsId,
    onFiltersChange,
    scanIds
  } = props

  const [filterList, setFilterList] = useState([])
  const [filterAttributes, setFilterAttributes] = useState([])
  const [newFilterName, setNewFilterName] = useState('')
  const [recorderOnline, setRecorderOnline] = useState(false)

  let fetchMethod = isDetailsView ? fetchDetails : fetchData
  let recorderPollingInterval = null

  const [{ data: filters, loading: loadingFilters, error: loadingFiltersError }] = useAxios({
    url: '/global/filters',
    method: 'GET',
    headers: getAuthHeader()
  })

  const [
    {
      data: recorderStatusData,
      lodading: recorderStatusLoading,
      error: recorderStatusError,
      response: recorderStatusResponse
    },
    fetchUrecorderStatus
  ] = useAxios(
    {
      baseURL: 'http://localhost:3001/',
      url: '/show-element',
      method: 'GET'
    },
    { manual: true }
  )

  const [{ data: newFilterData, loading: newFilterLoading, error: newFilterError }, saveNewFilter] = useAxios(
    {
      url: '/global/filters',
      method: 'POST',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const handleFetchScanCompare = filtersArr => {
    let scanA = compareData.scanA
    let scanB = compareData.scanB
    let documentA = details.document_a_id
    let documentB = details.document_b_id
    if (documentA && documentB) {
      fetchMethod({ data: { document_a: documentA, document_b: documentB, filters: filtersArr } })
    } else fetchMethod({ data: { scan_a: scanA, scan_b: scanB, filters: filtersArr } })
  }

  const onFilterAttributesChange = filterAttribs => {
    if (isScanCompare) handleFetchScanCompare(filterAttribs)
    else fetchMethod({ data: { filters: filterAttribs } })
    setFilterAttributes(filterAttribs)
    onFiltersChange && onFiltersChange(filterAttribs)
  }

  const onSaveNewFilter = newFilter => {
    let mappedProperties = newFilter.attributes.map(attr => {
      return {
        type: attr.type,
        condition: attr.condition,
        value: attr.value
      }
    })

    let filtersToSave = {
      name: newFilter.name,
      type: 'scan',
      properties: mappedProperties
    }

    setNewFilterName(newFilter.name)
    saveNewFilter({ data: filtersToSave })
  }

  // To update filters select with new saved filters
  useEffect(() => {
    if (filters) {
      setFilterList([...filterList, ...filters])
    }
    if (newFilterData && !newFilterData.Errors) {
      let data = {
        id: newFilterData.id,
        name: newFilterName
      }
      setFilterList([...filterList, data])
    }
  }, [filters, newFilterData])

  useEffect(() => {
    console.log('INITIAL FETCH')
    if (isScanCompare) handleFetchScanCompare(filterAttributes)
    else fetchMethod({ data: { filters: filterAttributes } })
  }, [fetchMethod])

  useEffect(() => {
    if (isDetailsView) {
      fetchUrecorderStatus({ useCahche: false }).catch(error => {
        setRecorderOnline(false)
      })
    }
  }, [isDetailsView])

  useEffect(() => {
    if (
      !recorderStatusError &&
      recorderStatusResponse &&
      recorderStatusResponse.status &&
      recorderStatusResponse.status == 200
    ) {
      setRecorderOnline(true)
    }
    if (isDetailsView && !recorderPollingInterval) {
      recorderPollingInterval = setInterval(() => {
        fetchUrecorderStatus({ useCahche: false, timeout: 15000 }).catch(error => {
          setRecorderOnline(false)
        })
      }, 15000)
    } else {
      if (recorderPollingInterval) {
        clearInterval(recorderPollingInterval)
      }
    }

    return () => {
      if (recorderPollingInterval) {
        clearInterval(recorderPollingInterval)
      }
    }
  }, [recorderStatusData, recorderStatusError, recorderStatusLoading, recorderStatusResponse])

  useEffect(() => {
    let interval
    if (withPolling) {
      interval = setInterval(() => {
        let isFailed = scanStatus && (scanStatus.includes('failed') || scanStatus.includes('error'))
        let isComplete = scanStatus && scanStatus.includes('complete')
        if (!scanStatus || (!isComplete && !isFailed)) {
          if (isScanCompare) handleFetchScanCompare(filterAttributes)
          else fetchMethod({ data: { filters: filterAttributes } })
        } else {
          if (interval) {
            clearInterval(interval)
          }
        }
      }, 10000)
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
      Modal.destroyAll()
    }
  }, [scanStatus, filterAttributes])

  let loadingFilterBar = newFilterLoading || loadingFilters
  let scans = scanViewData && (scanViewData.documents || scanViewData.entities)
  let stats = scanViewData && scanViewData.stats

  let initializing = isEmpty(scanViewData)
  let filtersError = loadingFiltersError || newFilterError
  let scanViewError = fetchError || filtersError || (newFilterData && newFilterData.Errors)
  if (isObject(scanViewError)) {
    scanViewError = scanViewError?.response?.data?.Errors
  }

  return (
    <Fragment>
      {scanViewError && <PageAlert message={scanViewError} />}
      {initializing && !scanViewError && <FullPageSpinner />}
      <ScanFilterBar
        filters={filterList}
        loading={loadingFilterBar}
        onFilterAttributesChange={onFilterAttributesChange}
        onNewFilterSave={onSaveNewFilter}
        isScanCompare={isScanCompare}
        isDetailsView={isDetailsView}
      />
      <ScanViewWidgets
        isDetailsView={isDetailsView}
        data={stats}
        widgets={widgets}
        gridColumns={widgetsGrid}
        isScanCompare={isScanCompare}
        scanIds={scanIds}
      />
      <ScanViewData
        data={scans}
        loading={loadingData}
        isDetailsView={isDetailsView}
        setDetailsView={setDetailsView}
        customColumns={customColumns}
        fetchDetails={fetchDetails}
        isScanCompare={isScanCompare}
        scanSettingsId={scanSettingsId}
        recorderOnline={recorderOnline}
        pageStats={stats}
      />
    </Fragment>
  )
}

export default ScanView
